import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing }) => ({
  wrapper: {
    maxWidth: "100%",
    gap: spacing(3),
    padding: spacing(2),
    borderRadius: 8,
    border: `1px solid ${grey["300"]}`,
  },
  mainText: {
    fontSize: "18px !important",
    lineHeight: 1.5,
    fontWeight: 500,
    textAlign: "center",
    maxWidth: "100%",
  },
  poweredByRow: {
    marginTop: spacing(1),
  },
  poweredByText: {
    color: grey[500],
    fontSize: "14px",
  },
}));
export default styles;
